import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'

import IntegrationAppAPI from 'api/integrationApp'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import InputText from 'components/forms/InputText'
import Button from 'components/forms/Button'

/**
 * Activity API form
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 *
 * @returns {React.Component}
 */
const ActivityAPIForm = (props) => {
  const { app, setApp } = props

  const [state, setState] = useState({
    callbackURL: app.activityApi?.callbackURL || '',
    secret: app.activityApi?.secret || ''
  })
  const [inProgress, setInProgress] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const onSubmit = useCallback(
    async (state) => {
      try {
        setInProgress(true)

        const appUpdate = await IntegrationAppAPI.updateById({
          identifier: app._id,
          activityApi: state
        })

        setApp(appUpdate)

        setDisabled(true)
        setInProgress(false)

        SaveToastNotification.ok()
      } catch (error) {
        setInProgress(false)

        SaveToastNotification.error()
      }

    }, [app._id]
  )

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()

        onSubmit(state)
      }}
    >
      <InputText
        required
        displayEdit={disabled}
        title={I18n.t('integration_app_activity_callback_url')}
        htmlFor='callbackURL'
        type='url'
        value={state.callbackURL}
        onChange={(text) => setState({ ...state, callbackURL: text })}
        disabled={disabled}
        onClickEdit={() => setDisabled(false)}
      />

      <InputText
        title={I18n.t('integration_app_activity_secret')}
        htmlFor='secret'
        value={state.secret}
        onChange={(text) => setState({ ...state, secret: text })}
        disabled={disabled}
      />

      <div className='integrations-app-edit__form-buttons'>
        {
          disabled
            ? null
            : (
              <>
                <Button
                  label={I18n.t('dashboard_cancel')}
                  color='secondary'
                  disabled={inProgress}
                  onClick={() => {
                    setDisabled(true)
                    setState({
                      callbackURL: app.activityApi?.callbackURL || '',
                      secret: app.activityApi?.secret || ''
                    })
                  }}
                />
                <Button
                  label={I18n.t('dashboard_save')}
                  className='integrations-app-edit__form-buttons-save'
                  disabled={inProgress}
                  type='submit'
                />
              </>
            )
        }
      </div>
    </form>
  )
}

export default ActivityAPIForm
